module.exports = __webpack_public_path__ + "img/Partner_08.31a6dae1.webp";